export const initialState = {
  deletionQueue: [],
  appToDelete: null,
};

export const AppDeleteActionsType = {
  ADD_TO_DELETION_QUEUE: "ADD_TO_DELETION_QUEUE",
  REMOVE_FROM_DELETION_QUEUE: "REMOVE_FROM_DELETION_QUEUE",
  SET_DELETING_APP: "SET_DELETING_APP",
};

export function appDeletionReducer(state = initialState, action) {
  switch (action.type) {
    case AppDeleteActionsType.ADD_TO_DELETION_QUEUE: {
      const { appid } = action.payload;
      if (state.deletionQueue.includes(appid)) return state;
      return {
        ...state,
        deletionQueue: [...state.deletionQueue, appid],
      };
    }
    case AppDeleteActionsType.REMOVE_FROM_DELETION_QUEUE: {
      const { appid } = action.payload;
      if (!state.deletionQueue.includes(appid)) return state;
      return {
        ...state,
        deletionQueue: state.deletionQueue.filter((item) => item !== appid),
      };
    }
    case AppDeleteActionsType.SET_DELETING_APP: {
      const { appid } = action.payload;
      return {
        ...state,
        appToDelete: appid,
      };
    }
    default:
      return state;
  }
}
